/**
 Validates org numbers from China
 */
export const validateChinaOrgNumber = (number: string) => {
  const chinaOrgNumberRegex = /^[A-Z0-9]{18}$/g;
  return chinaOrgNumberRegex.test(number);
};
